import { forms } from '../data/forms';

// SNAP-IV (DEHB VE ODD) HESAPLAMA MOTORU
export const calculateSnapIV = (answers) => {
  const testDef = forms.find(t => t.id === 'snap_iv_form');
  let inattention = { score: 0, critical: 0, max: 27, itemMax: 9, threshold: 6 };
  let hyperactivity = { score: 0, critical: 0, max: 27, itemMax: 9, threshold: 6 };
  let odd = { score: 0, critical: 0, max: 24, itemMax: 8, threshold: 4 };
  let risks = [];

  Object.keys(answers).forEach(key => {
    const id = parseInt(key);
    const val = parseInt(answers[key]) || 0;
    const isCritical = val >= 2; // "Oldukça" ve "Fazlasıyla" diyenler DSM'de pozitif (semptom var) sayılır
    const qText = testDef?.items?.find(q => q.id === id)?.text || `Madde ${id}`;

    let target = null; let catName = "";
    if (id >= 1 && id <= 9) { target = inattention; catName = "Dikkat Eksikliği"; }
    else if (id >= 10 && id <= 18) { target = hyperactivity; catName = "Hiperaktivite / Dürtüsellik"; }
    else if (id >= 19 && id <= 26) { target = odd; catName = "Karşıt Gelme Bozukluğu (ODD)"; }

    if (target) {
      target.score += val;
      if (isCritical) {
        target.critical += 1;
        risks.push({ id, text: qText, score: val, category: catName, isCritical: true });
      }
    }
  });

  const isRedAlarm = inattention.critical >= inattention.threshold || hyperactivity.critical >= hyperactivity.threshold || odd.critical >= odd.threshold;
  const isYellowAlarm = inattention.critical >= 4 || hyperactivity.critical >= 4 || odd.critical >= 3;

  let summary = "DENGELİ (NORMAL SEVİYE)"; let colorCode = "green";
  if (isRedAlarm) { summary = "YÜKSEK RİSK (KIRMIZI ALARM)"; colorCode = "red"; }
  else if (isYellowAlarm) { summary = "KLİNİK SINIRDA (SARI ALARM)"; colorCode = "amber"; }

 // --- YENİ EKLENEN STANDART PAKETLEME (ZARF) ---
  let masterRisk = "low";
  if (isRedAlarm) masterRisk = "high";
  else if (isYellowAlarm) masterRisk = "medium";

  // Toplam 78 ham puanı (27+27+24) evrensel sıralama için 100'lük risk skoruna çeviriyoruz
  const totalRawScore = inattention.score + hyperactivity.score + odd.score;
  const riskScore = Math.round((totalRawScore / 78) * 100);

  return {
    // 1. Ortak Dil (StudentFolders burayı okuyacak)
    riskScore: riskScore,
    masterRisk: masterRisk,
    isCritical: false, // DEHB ve ODD "high" düzeyde davranışsal risktir, ancak anlık hayati (critical) kriz değildir.
    domain: "behavioral", // Davranışsal alan

    // 2. Mevcut Detaylı Veriler (Dokunmadık)
    summary,
    colorCode,
    analysis: "SNAP-IV klinik taraması başarıyla tamamlandı.",
    risks,
    scores: { inattention, hyperactivity, odd },
    riskLevel: masterRisk // Geriye dönük uyumluluk
  };
};